import React from "react";
import { createPortal } from "react-dom";
import ModalCloseButton from "../../components/common/ModalCloseButton";
import 'react-medium-image-zoom/dist/styles.css';

const Modal = ({ open, setOpen, img }) => {

  if (!open) return null;

  // Portaled to <body>: inside the task-detail drawer (a transformed parent)
  // `fixed` would otherwise center on the drawer instead of the screen.
  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      {/* Small images sit centred in the minimum box; large ones are scaled
          down to fit the maximum (85% of the screen) and stay fully visible. */}
      <div className="relative flex min-h-[240px] min-w-[min(320px,85vw)] max-h-[85vh] max-w-[85vw] items-center justify-center overflow-hidden rounded-xl border-4 border-white bg-white shadow-2xl">
        <ModalCloseButton
          onClick={() => setOpen(false)}
          className="absolute top-2 right-2 bg-white shadow"
          ariaLabel="Close modal"
        />

        <img
          src={img}
          alt="Preview"
          className="block h-auto w-auto object-contain"
          style={{ maxHeight: "calc(85vh - 8px)", maxWidth: "calc(85vw - 8px)" }}
        />
      </div>
    </div>,
    document.body
  );
};

export default Modal;
